import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/biscuits/nice biscuit.png";
import BiscuitImg from "../../../assets/products/biscuits/Nice-Biscuit.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 27,
  },
  {
    grams: 36,
  },
  {
    grams: 45,
  },
];

export default function NiceProduct() {
  return (
    <>
      <Helmet>
        <title>Nice Biscuits – BearBitz | Premium Biscuits & Cookies</title>
        <meta
          name="description"
          content="Explore BearBitz Nice Biscuits—light, crispy, and perfect for any snack time. View pack sizes, cartons, and specs for global food manufacturing."
        />
        <meta name="keywords" content="Nice Biscuits, BearBitz Nice Biscuits" />
        <link rel="canonical" href="https://www.bearbitz.in/biscuits/nice" />
        <meta property="og:title" content="Nice Biscuits – BearBitz" />
        <meta
          property="og:description"
          content="Light and crispy Nice biscuits with global-ready specs and premium packaging."
        />
      </Helmet>

      <ProductTemplate
        productTitle="NICE BISCUITS"
        productImage={BisImg}
        description="Sprinkled with Sweet Simplicity. Golden coconut crunch with a touch of sugar sparkle-pure tea-time nostalgia. Exported for their elegance, enjoyed for their homely charm."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#004A67"
        sectionBgColor="#C4F7FF"
        productBgcolor="#1AE0FF"
        tableheadBgcolor="#1AE0FF"
        tableBgcolor="#E8FCFF"
        footerBgcolor="#1AE0FF"
      />
    </>
  );
}
